import React, { useEffect, useMemo, useState } from "react";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";
import AdvanceSearch from "../../../CommonComponents/AdvanceSearch";
import { useSelector } from "react-redux";
import visileColumns from "./visileColumns";
// import TelerikDataTable from "../../../CommonComponents/TelerikDataTable";
import TelerikDataTable from "../../../CommonComponents/TelerikDataTable/indexV2";

import  { forwardRef, useImperativeHandle } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Autocomplete, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { advanceSearch } from "../../../_helper/services/advanceSearchv2";
import { post, put } from "../../../_helper/api_helper";
import { ShowError, ShowSucess } from "../../../_helper/helper";

const AssignPocTable = forwardRef((props, ref) => {
    const id = 'vw_POC'
    const { columns, loadingSearch, ColumnsSorted, searchParameter, searchResultsV2 } = useSelector((state) => state.advanceSearchv2Reducer);
    const { results, rowCount } = useMemo(() => {
        const searchResult = searchResultsV2[id] || { results: [], rowCount: 0 };
        return {
          results: searchResult.results,
          rowCount: searchResult.rowCount,
        };
      }, [searchResultsV2, id]);
    const { filter: storeFilter, pageSize: storePageSize } = useSelector((state) => state.CommonReducer);
    const [page, setPage] = useState(1);
    const [additionalWhere, setAdditionalWhere] = useState("");
    const { sort } = useSelector((state) => state?.CommonReducer) || {};
    const [sortData, setSortData] = useState([
        // { field: "ANNOUNCEMENT_ID", dir: "desc" }  
    ]);
    const [searchParams, setSearchParams] = useState([]);
    const [pageSize, setPageSize] = useState(storePageSize[id] || 100);

    useEffect(() => {
        if (searchParameter[id]?.searchParams?.length > 0) {
            setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
        }
    }, [searchParameter]);

    const [sortedColumns, setSortedColumns] = useState(visileColumns);
    const [isOpen, setIsOpen] = useState(false);
    const [departmentOptions,setDepartmentOptions] = useState([])
    const [loading, setLoading] = useState(false);
    const [employeeOption,setEmployeeOption] = useState([])
    const [add,setAdd] = useState(false)
    const [submitLoading, setSubmitLoading] = useState(false);
    const [toggleApiCall,setToggleApiCall] = useState(false)
    const [updateData,setUpdateData] = useState({})

    const actions = useMemo(() => {
        return [
            {
                title: "Update",
                icon: { iconName: "k-icon k-i-pencil" },
                className: "font-primary",
                style: { cursor: "pointer" },
                action: (props) => {
                    console.log("added to table", props.dataItem);
                    setUpdateData({...props.dataItem})
                    const {Dept_Code,DepartmentName,EmployeeName,PocEmployeeid,IsActive} = props.dataItem
                    formik.setFieldValue("dept", {label:DepartmentName,value:Dept_Code});
                    formik.setFieldValue("empl", {label:EmployeeName,value:PocEmployeeid});
                    formik.setFieldValue("status", IsActive?'active':'inactive');
                    getEmployeeOption({label:DepartmentName,value:Dept_Code})
                    toggle();
                },
                
            },
            // {
            //     title: "Select",
            //     icon: { iconName: "k-icon k-i-radiobutton-checked" },
            //     className: "font-primary",
            //     style: { cursor: "pointer" },
            //     action: (props) => {
            //         // setEligibilityTableShow(props.dataItem);
            //     },
            //     isVisible: (dataProps) => {
            //         console.log("dataProps1221", dataProps?.ANNOUNCEMENT_ID?.trim(),ANNOUNCEMENT_ID_Value);
            //         return (
            //             dataProps?.ANNOUNCEMENT_ID?.trim() == ANNOUNCEMENT_ID_Value
            //         );
            //       },
            // }
        ];
    }, []);


    const getDepartmentOptions = async() => {
        const payload = {
            tableName: "vw_distinct_Dept_Code",
            searchParams: "[]",
            columns: "*",
            location: "global",
            pageNumber: 1,
            pageSize: 9999,
            sortData: "",
            additionalWhere: "",
            qID: 0,
          };
        try{
            const response = await advanceSearch(payload)
            const {results} = response
            if(results?.length>0){
                const deptOptions = results.map((item)=>({
                    label:item?.DepartmentName??"",
                    value:item?.Dept_Code
                }))
                setDepartmentOptions(deptOptions)
            }
            console.log(response,'deparment response')
        }catch(error){
            
        }
    }

    useEffect(()=>{
        getDepartmentOptions()
    },[])

    const handlePageChange = (event) => {
        setPage(event.page.skip / event.page.take + 1);
        setPageSize(event.page.take);
    };

    const handleSortChange = (sort) => {
        setSortData(sort);
        setPage(1);
        setPageSize(100);
    };

    const handleFilterChange = (data) => {
        setAdditionalWhere(data);
        setPage(1);
        setPageSize(100);
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };

    const toggle = () => setIsOpen(!isOpen);

    // Expose toggle function to parent component via ref
    useImperativeHandle(ref, () => ({
      openModal: () => toggle(),
      newAddition:()=>setAdd(true)
    }));
  
   // Formik setup for validation
   const formik = useFormik({
    initialValues: {
      status: 'active',
      dept: null,
      empl: null,
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Status is required'),
      dept: Yup.object().nullable().required('Department is required'),
      empl: Yup.object().nullable().required('Employee Name is required'),
    }),
    onSubmit: (values) => {
        submitHandler(values)
    //   toggle();
    },
  });

  const submitHandler = async(values) => {
    const {dept : {value:dept_code},empl:{value:empl_code}, status} = values
    setSubmitLoading(true);
    try{
        const payload = {
            "deptCode": dept_code,
            "pocEmployeeid": empl_code,
            // "assignedon": "2024-08-29T13:15:47.228Z",
            "isActive": status=='active',
            // "assignedby": 0,
            // "isdeleted": false
    }
    if(!add){
        payload['id'] = updateData.id
    }
        if(add)
        await post(`${process.env.REACT_APP_API_DOTNET_URL}/Lkdepartmentpoc/Lkdepartmentpoc`,payload)
        else await put(`${process.env.REACT_APP_API_DOTNET_URL}/Lkdepartmentpoc/LkdepartmentUpdated`,payload)
        setSearchParams([])
        toggle();
        ShowSucess("POC Assigned Sucessfully")
        if(add) setAdd(false)
        setToggleApiCall((prev)=>!prev)
        clearForm()
    }catch(error){
        ShowError("Something went wrong!")
    }finally{
        setSubmitLoading(false);
    }
    console.log('Form submitted:', dept_code,empl_code);
    // const response 
  }

  const getEmployeeOption = async(value) =>{
    setLoading(true);
      try {
        const payload = {
          tableName: "fn_verfiyEmployeeDep",
          searchParams: JSON.stringify([
            {
              columnName: "dept_no",
              operator: "=",
              value: value?.value,
              dataType: "varchar(max)",
              logicOperator: "AND",
            },
          ]),
          columns: "*",
          location: "global",
          pageNumber: 1,
          pageSize: 9999,
          sortData: "",
          additionalWhere: "",
          qID: 0,
        };
        const response = await advanceSearch(payload);
        const {results} = response
        if(results?.length>0){
            const emplOptions = results.map((item)=>({
                label:item?.EmployeeName??"",
                value:item?.employeeid
            }))
            setEmployeeOption(emplOptions)
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
  }

    const handleFirstAutocompleteChange = async (e, value) => {
      formik.setFieldValue("dept", value);
      formik.setFieldValue("empl", "")
      setEmployeeOption([]);
      await getEmployeeOption(value)
    };
  
    const clearForm = () => {
        formik.resetForm(); 
        setEmployeeOption([]); 
      };
  

  return (
    <Row>
      <Col sm="12" className="page-content">
        <Card>
          <CardBody>
            <div>
              <TelerikDataTable
                id={"vw_POC"}
                pageNumber={page}
                pageSize={pageSize}
                totalCount={rowCount}
                skip={(page - 1) * pageSize}
                take={pageSize}
                data={results || []}
                sortData={sortData}
                tableName={"vw_POC"}
                searchParams={searchParams}
                additionalWhere={additionalWhere}
                onFilterChange={handleFilterChange}
                onSortChange={handleSortChange}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
                selectedColumns={sortedColumns}
                setSortedColumns={setSortedColumns}
                loading={loadingSearch}
                enableFooterCell={false}
                toggleApiCall={toggleApiCall}
                // dataLocation="pmis-global"
                actions={actions}
                pocBool={true}
              />
            </div>
          </CardBody>

          <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Assign POC</ModalHeader>
            <ModalBody>
              <form onSubmit={formik.handleSubmit}>
                <RadioGroup
                  name="status"
                  value={formik.values.status}
                  onChange={(e) =>{
                    if(e.target.value!='active'){
                    formik.setFieldValue("empl", {label:updateData.EmployeeName,value:updateData.PocEmployeeid});
                    }
                    formik.setFieldValue("status", e.target.value)
                  }
                  }
                  row
                >
                  <FormControlLabel
                    value="active"
                    control={<Radio />}
                    label="Active"
                  />
                  <FormControlLabel
                    value="inactive"
                    control={<Radio />}
                    disabled={add}
                    label="Inactive"
                  />
                </RadioGroup>
                {/* <br /> */}
                <Autocomplete
                  options={departmentOptions}
                  getOptionLabel={(option) => option.label}
                  onChange={handleFirstAutocompleteChange}
                  value={formik.values.dept || null}
                  disabled={!add || formik.values.status!="active"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Department"
                      error={formik.touched.dept && Boolean(formik.errors.dept)}
                      helperText={formik.touched.dept && formik.errors.dept}
                      size="small"
                      disabled={!add || formik.values.status!="active"}
                    />
                  )}
                />
                <br />
                <Autocomplete
                  options={employeeOption}
                  getOptionLabel={(option) => option.label}
                  onChange={(e, value) => formik.setFieldValue("empl", value)}
                  value={formik.values.empl || null}
                  disabled={formik.values.status!="active"}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Employee for POC"
                      error={formik.touched.empl && Boolean(formik.errors.empl)}
                      helperText={formik.touched.empl && formik.errors.empl}
                      size="small"
                      disabled={formik.values.status!="active"}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loading ? <Spinner size="sm" /> : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
                <ModalFooter>
                  <Button color="secondary" onClick={()=>
                    {
                        setAdd(false)
                        clearForm()
                        toggle()
                    }
                    } disabled={submitLoading}>
                    Cancel
                  </Button>
                  <Button color="primary" type="submit" disabled={submitLoading}>
                  {submitLoading ? <Spinner size="sm" /> : 'Submit'}
                  </Button>
                </ModalFooter>
              </form>
            </ModalBody>
          </Modal>
        </Card>
      </Col>
    </Row>
  );
});

export default AssignPocTable;
